import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { Paginator } from 'components/general/Paginator';
import { StoreFrontItem } from 'components/glamclub/StoreFrontItem';
import { StoreFrontWrap } from 'components/glamclub/StoreFrontWrap';
import { UiActions } from 'state/actions/UiActions';

class Produtos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: this.props.match.params.page || 1,
      filteredProducts: [],
      originalState: [],
    };

    this.getProducts = this.getProducts.bind(this);
    this.orderBy = this.orderBy.bind(this);
    this.renderBrandsList = this.renderBrandsList.bind(this);
    this.setDistinctBrands = this.setDistinctBrands.bind(this);
    this.cleanFilter = this.cleanFilter.bind(this);
  }

  componentDidMount() {
    this.props.loaderShow();
    this.props.loadingStatusSet(true);
    this.getProducts();
  }

  getProducts() {
    const { history } = this.props;

    console.log(this.props.token.Authorization);

    ExecuteRequest(
      GlamboxEndpoints.GlamClub.listStorefront,
      {
        page: 0,
        pageSize: 400,
        searchKey: '',
      },
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        let { result, statusCode } = response;

        this.props.loaderHide();
        this.props.loadingStatusSet(false);

        if (statusCode === 200) {
          this.setState(
            {
              products: result.content,
              totalItems: result.totalElements,
              totalPages: result.totalPages,
              originalState: result.content,
            },
            () => {
              if (result.totalPages < this.state.currentPage) {
                history.push('/produtos/' + result.totalPages);
              }
            }
          );
        }
      }
    );
  }

  orderBy(obj, attribute, orderByDesc) {
    return () => {
      this.props.loaderShow();
      this.props.loadingStatusSet(true);

      setTimeout(() => {
        obj.sort((a, b) => {
          if (typeof a[attribute] === 'string') {
            return orderByDesc
              ? b[attribute].localeCompare(a[attribute])
              : a[attribute].localeCompare(b[attribute]);
          } else {
            return orderByDesc ? b[attribute] - a[attribute] : a[attribute] - b[attribute];
          }
        });
        this.props.history.push('/produtos');
        this.setState({ products: obj });
        this.props.loaderHide();
        this.props.loadingStatusSet(false);
      }, 500);
    };
  }

  //atualiza lista de produtos com as marcas
  setDistinctBrands(event) {
    let itemId = event.currentTarget.value;
    let filteredProductsByBrand = this.state.products.filter((item) => {
      return item.brandName === itemId;
    });

    this.props.history.push('/produtos');
    this.setState({ filteredProducts: filteredProductsByBrand });
  }

  renderBrandsList() {
    let { products } = this.state;
    let brands = [];

    products.forEach((item) => {
      if (!brands.includes(item.brandName)) {
        brands.push(item.brandName);
      }
    });

    brands.sort();
    brands = ['Selecione'].concat(brands);

    return brands.map((item, key) => {
      return (
        <option key={key} value={item}>
          {item}
        </option>
      );
    });
  }

  cleanFilter() {
    this.props.loaderShow();
    this.props.loadingStatusSet(true);

    setTimeout(() => {
      this.setState(
        {
          filteredProducts: [],
          products: this.state.originalState,
          currentPage: 1,
        },
        () => {
          this.getProducts();
          this.props.loadingStatusSet(false);
          this.props.loaderHide();
          this.forceUpdate();

          this.props.history.push('/produtos');
        }
      );
    }, 500);
  }

  renderPaginator = () => {
    const { match } = this.props;
    let { filteredProducts } = this.state;

    let products = filteredProducts.length > 0 ? filteredProducts : this.state.products;

    let len = products.length;

    if (this.state.filteredProducts.length < 1) {
      return (
        <Paginator
          page={match.params.page || 1}
          perPage={12}
          totalItems={len}
          baseUrl={'/produtos/'}
        />
      );
    }

    return null;
  };

  render() {
    const { match, location, history } = this.props;

    let { filteredProducts } = this.state;

    let currentPage = match.params.page || 1;

    let products = filteredProducts.length > 0 ? filteredProducts : this.state.products;

    const items = products.slice(currentPage * 12 - 12, currentPage * 12).map((item, key) => {
      return <StoreFrontItem productData={item} key={key} />;
    });

    let len = products.length;

    if (this.props.ui.loading === true) return null;

    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Minha Glambox : Glamclub</title>
        </Helmet>

        <h1>Glamclub</h1>

        <div className={'filter-glamclub d-flex flex-column flex-lg-row'}>
          <div className={'d-flex flex-row wrap-filter-buttons'}>
            <div className={'wrap-filter-div'}>
              <div className={'wrap-filter-block'}>
                <small> Nome </small>
                <div className={'wrap-filter-block-group'}>
                  <button
                    onClick={this.orderBy(this.state.products, 'productName', false)}
                    className={'level-3'}
                  >
                    [a/z]
                  </button>
                  <button
                    onClick={this.orderBy(this.state.products, 'productName', true)}
                    className={'level-3'}
                  >
                    [z/a]
                  </button>
                </div>
              </div>
              <div className={'wrap-filter-block'}>
                <small> Glampoints</small>
                <div className={'wrap-filter-block-group'}>
                  <button
                    onClick={this.orderBy(this.state.products, 'tradePoints', true)}
                    className={'level-3'}
                  >
                    maior
                  </button>
                  <button
                    onClick={this.orderBy(this.state.products, 'tradePoints', false)}
                    className={'level-3'}
                  >
                    menor
                  </button>
                </div>
              </div>
              <div className={'wrap-filter-block'}>
                <small> Avaliação</small>
                <div className={'wrap-filter-block-group'}>
                  <button
                    onClick={this.orderBy(this.state.products, 'ratingAverage', true)}
                    className={'level-3'}
                  >
                    alta
                  </button>
                  <button
                    onClick={this.orderBy(this.state.products, 'ratingAverage', false)}
                    className={'level-3'}
                  >
                    baixa
                  </button>
                </div>
              </div>
              <div className={'wrap-filter-block marcas'}>
                <small>Filtrar marcas:</small>
                <select onChange={this.setDistinctBrands} className={'level-3'}>
                  {this.renderBrandsList()}
                </select>
              </div>
            </div>
            <div className={'wrap-filter-block clear'}>
              <small>&nbsp;</small>
              <button onClick={this.cleanFilter} className={'level-3'}>
                {' '}
                Limpar Filtro
              </button>
            </div>
          </div>
        </div>

        <StoreFrontWrap>{items}</StoreFrontWrap>

        {this.renderPaginator()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.token.data,
  ui: state.ui,
});

const mapDispatchToProps = (dispatch) => ({
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loadingStatusSet: (status) => {
    dispatch(UiActions.setLoadingStatus(status));
  },
});

Produtos = connect(mapStateToProps, mapDispatchToProps)(Produtos);

export { Produtos };
